import { Box } from '@mui/material';
import * as React from 'react';
import { flexCenter } from '../commonUI/cssClasses';
import settingsLottie from '../commonUI/icons/settings.json';
import LottiePlayer from '../commonUI/LottiePlayer';
import TooltipPopup from '../commonUI/tooltips/TooltipPopup';
import { ImageSettingsPopup } from './ImageSettingsPopup';

export const SettingsButton: React.FC = () => {
  return (
    <TooltipPopup
      popupComponent={(isTooltipOpen) => (
        <ImageSettingsPopup isTooltipOpen={isTooltipOpen} />
      )}
      colorScheme='dark'
    >
      <Box sx={{ ...flexCenter }}>
        <LottiePlayer lottieJSON={settingsLottie} playOnHover pxSize={24} />
      </Box>
    </TooltipPopup>
  );
};
